<template>
  <div>
    <div class="order-header">
      <div class="order-title">
        <span>支付中心</span>
      </div>
    </div>
    <el-card class="cart-body">
      <div class="box">
        <div style="padding: 20px 0 20px 0">
          <p class="goods-info-tile">订单：{{order.id}}</p>
        </div>
        <el-card class="goods-info">
          <el-row style="margin: 20px">
            <el-col :span="4">
                <el-image style="width: 150px;height: 100px;cursor: pointer"
                          v-if="course.image !== undefined"
                          :src="course.image"
                          @click="toDetail">
                </el-image>
            </el-col>
            <el-col :span="13">
                <p style="color: #07111b;cursor: pointer" @click="toDetail">
                  【{{course.courseType === 'O'?'技术人员培训学习':course.courseType === 'C'?'技术人员宣贯学习':''}}】
                  {{course.name}}
                </p>
            </el-col>
            <el-col :span="7">
              <div style="margin-top: 35px;">
                <span style="color: #93999f">价格 ：</span>
                <span style="color: #f01414;font-size: 18px">￥ {{course.price}}</span>
              </div>
            </el-col>
          </el-row>
        </el-card>
        <div class="pay-methods">
          <h2 class="pay-method-title">支付方式</h2>
          <el-row>
            <!-- 已隐藏 -->
            <el-col :span="5" hidden>
              <el-card class="pay-way zfb-bg" @click.native="paidType = 'Z'" :class="{'active': paidType === 'Z'}">
                <div class="bottom-right" :class="{'active-bottom-right': paidType === 'Z'}">
                  <div class="triangle"></div>
                  <i class="el-icon-check"></i>
                </div>
              </el-card>
            </el-col>
            <el-col :span="5">
              <el-card class="pay-way wx-bg" @click.native="paidType = 'W'" :class="{'active': paidType === 'W'}">
                <div class="bottom-right" :class="{'active-bottom-right': paidType === 'W'}">
                  <div class="triangle"></div>
                  <i class="el-icon-check"></i>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
        <div class="pay-foot">
          <el-row>
            <el-col :span="5" style="padding-top: 32px">
              <div>
                <el-alert title="请完成支付" type="warning" show-icon :closable="false"
                          style="background-color: #FFFFFF;color: #f90"/>
              </div>
            </el-col>
            <el-col :span="14">
              <div style="height: 1px"></div>
            </el-col>
            <el-col :span="5">
              <div style="padding-top: 36px;float: right">
                <div>
                  <span>应付金额：</span>
                  <span class="price">￥ {{course.price}}</span>
                </div>
                <div style="margin: 32px 0 16px 0;text-align: right">
                  <el-button type="danger" style="background-color:#f01414" @click="toPay">立即支付</el-button>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-card>.

    <!-- 点击立即支付后弹出提示框 -->
    <el-dialog
            :show-close="false"
            :close-on-click-modal=false
            top=30vh
            title="订单支付中, 请稍等...."
            :visible.sync="tipVisible"
            width="25%"
            center>
      <strong style="color: red; margin: 20%">请在最新打开的页面中完成订单支付。</strong>
      <span slot="footer" class="dialog-footer">
    <el-button @click="tipVisible = false">取消支付</el-button>
    <el-button type="primary" @click="yesPay">完成支付</el-button>
  </span>
    </el-dialog>

    <!-- 支付二维码 -->
    <!--<el-dialog title="微信支付"
               top="250px"
               :visible.sync="dialogFormVisible"
               width="360px"
               :lock-scroll="false"
               :close-on-click-modal="true"
               :destroy-on-close="true">

      <qriously :value="order.code_url" :size="250" style="margin-left: 35px"/>
      <span style="margin-left: 80px">请用微信扫描二维码支付</span>
      <p style="color: red;letter-spacing:2px;font-size: 14px;margin-left: 120px;">￥{{order.total_fee}}</p>
    </el-dialog>-->

    <!--<form :model="viewBagForm" action="https://www.gnetpg.com/GneteMerchantAPI/api/PayV36" method="post">
      <input type="text" v-model="viewBagForm.MerId"></input>
      <input type="text" v-model="viewBagForm.OrderNo"></input>
      <input type="text" v-model="viewBagForm.OrderAmount"></input>
      <input type="text" v-model="viewBagForm.CurrCode"></input>
      <input type="text" v-model="viewBagForm.OrderType"></input>
      <input type="text" v-model="viewBagForm.CallBackUrl"></input>
      <input type="text" v-model="viewBagForm.BankCode"></input>
      <input type="text" v-model="viewBagForm.LangType"></input>
      <input type="text" v-model="viewBagForm.BuzType"></input>
      <input type="text" v-model="viewBagForm.Reserved01"></input>
      <input type="text" v-model="viewBagForm.Reserved02"></input>
      <input type="text" v-model="viewBagForm.SignMsg"></input>
      <input type="submit" value="Submit">
    </form>-->
  </div>
</template>

<script>
  import {urlencodedDataType} from "../../axios/ajax.config";
  import merge from 'webpack-merge'

  export default {
    name: "orderPay",
    data() {
      return {
        isOwn: document.verifyIsHidden,
        course: Object, // 课程对象
        order: Object, // 订单对象
        pay: Object,
        paidType: 'W',
        dialogFormVisible: false,//二维码
        timer:'', //定时器
        tipVisible: false, //支付提示框
        flat: 0,
        url: 'https://www.gnetpg.com/GneteMerchantAPI/api/PayV36',
        //VIEWBAG_FROM: 'viewBagForm',
        viewBagForm: {
          MerId: '',
          OrderNo: '',
          OrderAmount: '',
          CurrCode: '',
          OrderType: '',
          CallBackUrl: '',
          BankCode: '',
          LangType: '',
          BuzType: '',
          Reserved01: '',
          Reserved02: '',
          SignMsg: ''
        }
      }
    },
    beforeRouteLeave (to, from, next) {
      // 导航离开该组件的对应路由时调用
      // 可以访问组件实例 `this`
      if(this.timer){
        clearInterval(this.timer);
      }
      next();
    },
    destroyed() {
      // 清除popstate事件 否则会影响到其他页面
      window.removeEventListener("popstate", this.disableBrowserBack, false)
    },
    mounted() {
      // 禁用浏览器返回键
      history.pushState(null, null, document.URL);
      window.addEventListener('popstate', this.disableBrowserBack);
      //在页面渲染之后执行
      //每隔三秒，去查询一次支付状态
      this.timer = setInterval(() => {
        //this.$http.get('/business/web/order/payStatus',{params:{orderId:this.$route.params.orderId}});
          this.queryPayStatus();
        /*console.log("=======================================");
        console.log(this.isOwn)*/
      }, 3000);
    },
    methods: {
      //禁用浏览器返回
      disableBrowserBack() {
        history.pushState(null, null, document.URL);
      },
      async yesPay(){
        this.tipVisible = false;
        const { content } = await this.$http.get('/business/web/order/isPay',{params:{orderId:this.$route.params.orderId}});
        if (content){
          clearInterval(this.timer);
          const params = {
            id: this.$route.params.orderId,
            userId: this.$store.state.userInfo.id,
            courseId: this.course.id,
            paidType: this.paidType,
            serialNumber: '123'
          };
          Toast.success("支付成功，自动跳转中....");
          await this.$http.post('/business/web/order/completeOrder', params);
          setTimeout(() => {
            this.toDetail();
          }, 3000);
        }else {
          //this.$message.error('支付未成功，请检查或重新支付！');
          Toast.error("支付未成功，请检查或重新支付！");
        }
      },
      async toPay() {

        const params = {
          id: this.order.id,
          userId: this.$store.state.userInfo.id,
          courseId: this.course.id,
          paidType: this.paidType,
          serialNumber: '123'
        };

        //const { success } = await this.$http.post('/business/web/order/completeOrder', params);

        const { content } = await this.$http.get('/business/web/order/toPay', {params:{orderId:this.$route.params.orderId}});
        this.viewBagForm = content;
        //改变路由订单号
        this.$router.push({
          params:merge(this.$route.params,{'orderId':this.viewBagForm.OrderNo})
        })
        //改变页面显示订单号
        this.order.id = this.viewBagForm.OrderNo;

        //window.location.href = this.url+"?MerId="+this.viewBagForm.MerId+"&OrderNo="+this.viewBagForm.OrderNo+"&OrderAmount="+this.viewBagForm.OrderAmount+"&CurrCode="+this.viewBagForm.CurrCode+"&OrderType="+this.viewBagForm.OrderType+"&CallBackUrl="+this.viewBagForm.CallBackUrl+"&BankCode="+this.viewBagForm.BankCode+"&LangType="+this.viewBagForm.LangType+"&BuzType="+this.viewBagForm.BuzType+"&Reserved01="+this.viewBagForm.Reserved01+"&Reserved02="+this.viewBagForm.Reserved02+"&SignMsg="+this.viewBagForm.SignMsg;
        //location.replace(this.url+"?MerId="+this.viewBagForm.MerId+"&OrderNo="+this.viewBagForm.OrderNo+"&OrderAmount="+this.viewBagForm.OrderAmount+"&CurrCode="+this.viewBagForm.CurrCode+"&OrderType="+this.viewBagForm.OrderType+"&CallBackUrl="+this.viewBagForm.CallBackUrl+"&BankCode="+this.viewBagForm.BankCode+"&LangType="+this.viewBagForm.LangType+"&BuzType="+this.viewBagForm.BuzType+"&Reserved01="+this.viewBagForm.Reserved01+"&Reserved02="+this.viewBagForm.Reserved02+"&SignMsg="+this.viewBagForm.SignMsg);
        window.open(this.url+"?MerId="+this.viewBagForm.MerId+"&OrderNo="+this.viewBagForm.OrderNo+"&OrderAmount="+this.viewBagForm.OrderAmount+"&CurrCode="+this.viewBagForm.CurrCode+"&OrderType="+this.viewBagForm.OrderType+"&CallBackUrl="+this.viewBagForm.CallBackUrl+"&BankCode="+this.viewBagForm.BankCode+"&LangType="+this.viewBagForm.LangType+"&BuzType="+this.viewBagForm.BuzType+"&Reserved01="+this.viewBagForm.Reserved01+"&Reserved02="+this.viewBagForm.Reserved02+"&SignMsg="+this.viewBagForm.SignMsg);
        //弹框
        this.tipVisible = true;

        /*const orderId = this.$route.params.orderId;
        const { content } = await this.$http.get('/business/web/order/createNative',{params:{orderId:orderId}});
        if (content) {
          this.flat = 1;
          this.order = content;

        }
        this.dialogFormVisible = true;*/
        /*const { success } = await this.$http.post('/business/web/order/payStatus', {params:{orderId:orderId}});
        console.log("-----------------------------------------------------------------------------------------------");
        console.log(success);*/
        /*if (true) {
          Toast.success("支付成功");
          setTimeout(() => {
            this.toDetail();
          }, 2000);
        }*/
        /*const { success } = await this.$http.post('/business/web/order/completeOrder', params);
        if (success) {
          Toast.success("支付成功");
          setTimeout(() => {
            this.toDetail();
          }, 1000);
        }*/
      },
      async queryPayStatus(){
        const { content } = await this.$http.get('/business/web/order/isPay',{params:{orderId:this.$route.params.orderId}});
        if (content){
          const params = {
            id: this.$route.params.orderId,
            userId: this.$store.state.userInfo.id,
            courseId: this.course.id,
            paidType: this.paidType,
            serialNumber: '123'
          };
          clearInterval(this.timer);
          this.tipVisible = false;
          Toast.success("支付成功，自动跳转中....");
          //保存订单
          await this.$http.post('/business/web/order/completeOrder', params);
          setTimeout(() => {
            this.toDetail();
          }, 3000);
        }
      },
      toDetail() {
        let routerName = '';
        if (this.course.courseType === 'O') {
          routerName = 'TrainDetail';
        }else if (this.course.courseType === 'C') {
          routerName = 'EduDetail';
        }
        this.$router.push({ name: routerName, params: { courseId: this.course.id } });
      }
    },
    async created() {
      const courseId = this.$route.params.courseId;
      const { content } = await this.$http.get('/business/web/course/getOneById',{params:{courseId:courseId}});
      if (content) {
        this.course = content;
      }
      this.order = {
        id: this.$route.params.orderId
      }
    }
  }
</script>

<style lang="scss" scoped>
  .order-header {
    height: 160px;
    background: url("../../assets/img/cart-bg.png") repeat-x left bottom;
  }
  .order-title {
    width: 60%;
    height: 88px;
    margin: 0 auto;
    line-height: 120px;
  }
  .order-title span {
    font-size: 32px;
    color: #07111b;
    font-weight: 200;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  }
  .cart-body {
    width: 60%;
    margin: -40px auto 50px auto;
    height: 660px;
    border-radius: 8px;
    min-width: 1100px;
  }
  .cart-body /deep/ .el-card__body {
    padding: 0;
  }
  .cart-body .box {
    width: 94%;
    margin: 0 auto;
    height: 660px;
  }
  .goods-info-tile {
    margin-left: 12px;
    color: #07111b;
    font-size: 16px;
    line-height: 16px;
  }
  .goods-info {
    width: 100%;
    height: 140px;
    background-color: #f3f5f7;
    margin-bottom: 25px;
  }
  .pay-methods {
    padding: 20px 12px 0;
    height: 200px;
    border-top: 1px solid #d9dde1;
  }
  .pay-method-title {
    height: 46px;
    line-height: 30px;
    font-size: 16px;
    font-weight: 400;
    color: #07111b;
  }
  .pay-way {
    width: 90%;
    height: 90px;
    border: 2px solid #f3f5f7;
    box-shadow: 0 0;
    position: relative;
    cursor: pointer;
    border-radius: 6px;

    &:hover {
      border-color: #f01414;
      .bottom-right {
        display: block;
      }
    }
  }
  .active {
    border-color: #f01414;
  }
  .zfb-bg {
    /*background-image: url("../../assets/img/wangfutong.png");*/
    background: url("../../assets/img/wangfutong.png") no-repeat center;

  }
  .wx-bg {
    /*background-image: url("../../assets/img/weixin.jpg");
    background-size: cover;*/
    background: url("../../assets/img/wangfutong.png") no-repeat center;
  }
  .bottom-right {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 0;
    bottom: 0;
    display: none;
  }
  .active-bottom-right {
    display: block;
  }
  .triangle {
    width: 0;
    height: 0;
    border-bottom: 20px solid red;
    border-left: 20px solid transparent;
  }
  .el-icon-check {
    position: absolute;
    color: #FFFFFF;
    font-size: 12px;
    bottom: 0;
    right: -1px;
  }
  .pay-foot {
    width: 100%;
    height: 176px;
    border-top: 1px solid #d9dde1;
  }
  .price {
    font-size: 24px;
    color: #f01414;
  }

</style>
